var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React from "react";
import { Row } from "react-bootstrap";
import EdButton from "@frameworks/web/components/generic/edbutton/edButton";
import GenericTable from "@frameworks/shared-library/components/GenericTable";
import InputField from "@frameworks/web/components/generic/inputField";
import di from "@frameworks/salesjourney/components/Features/ClientDetails/di/serviceLocator";
import { useSelector } from "react-redux";
import Inputtablebottom from "@frameworks/salesjourney/components/Generic/Inputtablebottom";
import { accountDetails } from "@salesdi";
import EdModal from "@frameworks/web/components/generic/edModal";
import AddFamilyMember from "./FamilyTagging/AddFamilyMember";
import Verificationpopup from "./FamilyTagging/Verificationpopup";
import MessagePopup from "./FamilyTagging/MessagePopup";
import resetpassword from "@frameworks/web/assets/images/generic/passwordreset.svg";
import { ErrorText } from "./constents";
export var inputfield = {
    serachVal: "",
};
var FamilyTaggingPop = function (props) {
    var _a, _b, _c;
    var _d = __read(React.useState([]), 2), MasterRelation = _d[0], setMasterRelation = _d[1];
    var _e = __read(React.useState({}), 2), selectedElement = _e[0], setselectedElement = _e[1];
    var _f = __read(React.useState([]), 2), FamilyMemberDetailsData = _f[0], setFamilyMemberDetailsData = _f[1];
    var selectedAcount = useSelector(function (state) { return state.Clients.ClientSearch.reducersData.selected; });
    var _g = __read(React.useState(null), 2), formData = _g[0], setFormData = _g[1];
    var _h = __read(React.useState(inputfield), 2), error = _h[0], setError = _h[1];
    var _j = __read(React.useState(), 2), selectedAddFamilyMember = _j[0], setSelectedAddFamilyMember = _j[1];
    var _k = __read(React.useState([]), 2), searchData = _k[0], setSearchData = _k[1];
    var _l = __read(React.useState(false), 2), searchLoader = _l[0], setSearchLoader = _l[1];
    var _m = __read(React.useState(false), 2), openState = _m[0], setOpenState = _m[1];
    var _o = __read(React.useState(), 2), selectedFamilyTagging = _o[0], setSelectedFamilyTagging = _o[1];
    var _p = __read(React.useState(false), 2), addFamilyMemeber = _p[0], SetAddFamilyMemeber = _p[1];
    var _q = __read(React.useState(), 2), familyHeadDetails = _q[0], setFamilyHeadDetails = _q[1];
    var _r = __read(React.useState(false), 2), resetFamilyAddForm = _r[0], setResetFamilyAddForm = _r[1];
    var _s = __read(React.useState(false), 2), successfulMsg = _s[0], setSuccessfulMsg = _s[1];
    var _t = __read(React.useState(false), 2), verifyPopupEmail = _t[0], setverifyPopupEmail = _t[1];
    var _u = __read(React.useState(false), 2), verifyPopupMobile = _u[0], setverifyPopupMobile = _u[1];
    var _v = __read(React.useState(false), 2), mobileOtpSentSuccess = _v[0], setMobileOtpSentSuccess = _v[1];
    var _w = __read(React.useState(false), 2), emailOtpSentSuccess = _w[0], setEmailOtpSentSuccess = _w[1];
    var userId = useSelector(function (state) { var _a, _b, _c, _d, _e; return (_e = (_d = (_c = (_b = (_a = state === null || state === void 0 ? void 0 : state.Profile) === null || _a === void 0 ? void 0 : _a.ProfileDetails) === null || _b === void 0 ? void 0 : _b.reducersData) === null || _c === void 0 ? void 0 : _c.data) === null || _d === void 0 ? void 0 : _d.profileDetails) === null || _e === void 0 ? void 0 : _e.userId; });
    var validationError = function (field, value) {
        var _a;
        setError(__assign(__assign({}, error), (_a = {}, _a[field] = value, _a)));
    };
    var handleChange = function (event) {
        var _a;
        setFormData(__assign(__assign({}, formData), (_a = {}, _a[event.currentTarget.name] = event.currentTarget.value, _a)));
    };
    var _x = __read(React.useState(), 2), selectedIndex = _x[0], setSelectedIndex = _x[1];
    var _y = useSelector(function (state) { return state.Clients.FamilyMemDetails; }), familyMemDetails = _y.reducersData, FamilyMemDetailsCommon = _y.commonData;
    var deleteFamilyMember = function (memberAcCode) { return __awaiter(void 0, void 0, void 0, function () {
        var payload, deleted;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    payload = {
                        acCode: memberAcCode,
                        page: "1",
                        pageSize: "1",
                    };
                    return [4 /*yield*/, di.clients.deleteFamilyMember(payload)];
                case 1:
                    deleted = _a.sent();
                    if (deleted.status && selectedAcount)
                        getFamilyDetails();
                    return [2 /*return*/];
            }
        });
    }); };
    var getVerifiedFlags = function (memberAccountCode, callBackFunctionSuccess, callBackFunctionError, isMobile) {
        var selectedFamilyAccount = null;
        di.clients
            .getFamilyMemDetails({
            acCode: selectedAcount === null || selectedAcount === void 0 ? void 0 : selectedAcount.accountCode,
            page: "1",
            pageSize: "100",
        })
            .then(function (resp) {
            if (resp && (resp === null || resp === void 0 ? void 0 : resp.length) > 0) {
                resp === null || resp === void 0 ? void 0 : resp.map(function (familyAccount) {
                    if ((familyAccount === null || familyAccount === void 0 ? void 0 : familyAccount.memberAcCode) == memberAccountCode) {
                        callBackFunctionSuccess(familyAccount, isMobile);
                    }
                });
            }
            else {
                callBackFunctionError(isMobile);
            }
        })
            .catch(function (error) {
            callBackFunctionError(isMobile);
        });
        return selectedFamilyAccount;
    };
    var deleteFamily = function (accCode) { return __awaiter(void 0, void 0, void 0, function () {
        var payload, deleted;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    // console.log("accCode", selectedElement.memberAcCode);
                    console.log("accCode", selectedElement.memberAcCode);
                    payload = {
                        acCode: accCode,
                        page: "1",
                        pageSize: "1",
                    };
                    return [4 /*yield*/, di.clients.deleteFamily(payload)];
                case 1:
                    deleted = _a.sent();
                    if (deleted.status && selectedAcount) {
                        getFamilyDetails();
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var addFamilyHead = function (accountCode) { return __awaiter(void 0, void 0, void 0, function () {
        var payload, _a, addedFamHead;
        var _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _b = {
                        familyheadaccodeold: familyHeadDetails && (familyHeadDetails === null || familyHeadDetails === void 0 ? void 0 : familyHeadDetails.length) > 0
                            ? familyHeadDetails[0].headAcCode
                            : "",
                        familyheadaccodenew: accountCode
                    };
                    _a = Number;
                    return [4 /*yield*/, accountDetails.getSalesuserId()];
                case 1:
                    payload = (_b.userID = _a.apply(void 0, [_c.sent()]),
                        _b.smsFlag = "",
                        _b.familymemberdetails = [],
                        _b);
                    return [4 /*yield*/, di.clients.addFamilyMemDetails(payload)];
                case 2:
                    addedFamHead = _c.sent();
                    if (addedFamHead.status && selectedAcount)
                        getFamilyDetails();
                    return [2 /*return*/];
            }
        });
    }); };
    var getSearchDetails = function (searchText) {
        setSearchLoader(true);
        var searchTagging = {
            searchValue: searchText,
            page: 1,
            pageSize: 100,
        };
        di.clients
            .getSearchFamilyTagging(searchTagging)
            .then(function (searchResp) {
            setSearchData(searchResp);
            setSearchLoader(false);
        })
            .catch(function (error) {
            setSearchData([]);
            setSearchLoader(false);
        });
    };
    var sendLoa = function (searchvalue) { return __awaiter(void 0, void 0, void 0, function () {
        var message, _a, _b;
        var _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    _b = (_a = di.clients).sendLoaDetails;
                    _c = {};
                    return [4 /*yield*/, accountDetails.getSalesuserId()];
                case 1: return [4 /*yield*/, _b.apply(_a, [(_c.rediskey = _d.sent(),
                            _c.searchValue = searchvalue,
                            _c)])];
                case 2:
                    message = _d.sent();
                    alert(message === null || message === void 0 ? void 0 : message.data);
                    return [2 /*return*/];
            }
        });
    }); };
    var resendOtp = function (isMobile, relation, memberAcCode) {
        var _a, _b;
        setMobileOtpSentSuccess(false);
        var reqobj = {
            userID: userId,
            familyheadaccodenew: familyHeadDetails[0].headAcCode,
            familyheadaccodeold: familyHeadDetails[0].headAcCode,
            familymemberdetails: [
                {
                    relation: relation
                        ? relation === null || relation === void 0 ? void 0 : relation.toString()
                        : (_a = selectedElement.relation) === null || _a === void 0 ? void 0 : _a.toString(),
                    accode: memberAcCode
                        ? memberAcCode === null || memberAcCode === void 0 ? void 0 : memberAcCode.toString()
                        : (_b = selectedElement.memberAcCode) === null || _b === void 0 ? void 0 : _b.toString(),
                    otp: "",
                },
            ],
            smsFlag: "O",
        };
        if (isMobile) {
            reqobj.familymemberdetails[0].otponsms = "1";
        }
        else {
            reqobj.familymemberdetails[0].otponemail = "1";
        }
        setSelectedFamilyTagging(reqobj);
        saveFamilyTagging(reqobj).then(function (resp) {
            if (resp.status) {
                if (isMobile) {
                    setMobileOtpSentSuccess(true);
                    setverifyPopupMobile(function (verifyOtp) {
                        verifyOtp = true;
                        return verifyOtp;
                    });
                }
                else {
                    setEmailOtpSentSuccess(true);
                    setverifyPopupEmail(function (verifyOtp) {
                        verifyOtp = true;
                        return verifyOtp;
                    });
                }
            }
        });
    };
    var FamilyColumn = [
        {
            columnName: "Family Head",
            key: "headAcCode",
            tdCustomFunction: function (key) {
                return (React.createElement(React.Fragment, null,
                    React.createElement("div", { className: "position-relative" },
                        React.createElement(InputField, { placeholderClassName: "DMSanM_14_500 txt_blackOne1", onBlur: function (error, event) {
                                if (error.required)
                                    validationError(event.target.name, "This field is Required");
                                else
                                    validationError(event.target.name, "");
                            }, onChangeEvent: function (e) {
                                if (e.target.value) {
                                    setOpenState(true);
                                    getSearchDetails(e.target.value);
                                }
                                handleChange(e);
                            }, value: key, errorText: error.serachVal, defaultValue: key, id: "add-upi", name: "add-upi", maxLength: 10, required: true, autoComplete: "off" }),
                        openState && searchData.length > 0 && (React.createElement("div", { className: "position-absolute bg_white add-family-member " },
                            React.createElement(Inputtablebottom, { clientSearchList: searchData, loader: searchLoader, clientSearchFlag: true, setCallbackFunction: function (data) {
                                    setOpenState(false);
                                    setFormData({ serachVal: data.accountCode });
                                    setFamilyHeadDetails(function (familyHeadDetails) {
                                        familyHeadDetails[0].headAcCode = data.accountCode;
                                        familyHeadDetails[0].headAcName = data.clientName;
                                        return familyHeadDetails;
                                    });
                                    // di.clients.setSelectedClientOnSearchClick(data);
                                    // props?.setsearchText("");
                                }, errorText: ErrorText }))))));
            },
        },
        {
            columnName: "Family Head Name",
            key: "headAcName",
            key2: "headAcCode",
            tdCustomFunction: function (key, key2) {
                return (key && (React.createElement("span", null,
                    key,
                    React.createElement("span", null,
                        "(",
                        key2,
                        ")"))));
            },
        },
        // {
        //   columnName: "LOA",
        //   key: "loa",
        //   key2: "headAcName",
        //   tdCustomFunction: (key: string, key2: string) => {
        //     return (
        //       <div className="familytagging-btn">
        //         <EdButton
        //           btnTyp={"midnight-blue-underline"}
        //           value={key}
        //           onClick={() => {
        //             sendLoa(key2);
        //           }}
        //         />
        //       </div>
        //     );
        //   },
        // },
        {
            columnName: "",
            key: "button",
            tdCustomFunction: function () {
                return (React.createElement("div", { className: "familytagging-btn" },
                    React.createElement(EdButton, { btnTyp: "midnight-blue", value: "Save", disabled: !((formData === null || formData === void 0 ? void 0 : formData.serachVal) && (formData === null || formData === void 0 ? void 0 : formData.serachVal) !== ""), type: "button", onClick: function () {
                            addFamilyHead(formData.serachVal);
                        } }),
                    React.createElement(EdButton, { btnTyp: "midnight-blue-border", type: "button", value: "Delete", onClick: function () {
                            if (selectedAcount === null || selectedAcount === void 0 ? void 0 : selectedAcount.accountCode)
                                deleteFamily(selectedAcount === null || selectedAcount === void 0 ? void 0 : selectedAcount.accountCode);
                        } })));
            },
        },
    ];
    var RelationColumn = [
        {
            columnName: "Relation",
            key: "relation",
            tdCustomFunction: function (key) {
                var relationShipName = "";
                if ((MasterRelation === null || MasterRelation === void 0 ? void 0 : MasterRelation.length) > 0) {
                    MasterRelation.map(function (record) {
                        if (record.valueid === Number(key)) {
                            relationShipName = record.valuename;
                        }
                    });
                }
                return React.createElement(React.Fragment, null, relationShipName);
            },
        },
        {
            columnName: "Account Code",
            key: "memberAcCode",
        },
        {
            columnName: "Name",
            key: "memberName",
        },
        {
            columnName: "Mobile No.",
            keysForCustomFunction: [
                "mobileNo",
                "otpOnMobile",
                "relation",
                "memberAcCode",
                "status",
            ],
            tdCustomFunction: function (keysForCustomFunction) {
                return (React.createElement(React.Fragment, null,
                    React.createElement("span", null, keysForCustomFunction[0]),
                    keysForCustomFunction[4] !== null &&
                        keysForCustomFunction[4] !== undefined &&
                        keysForCustomFunction[4] !== "" &&
                        keysForCustomFunction[4].length > 0 && (React.createElement(React.Fragment, null, keysForCustomFunction[4] === "Pending" && (React.createElement(React.Fragment, null,
                        React.createElement("div", { className: "familytagging-btn" },
                            React.createElement(EdButton, { btnTyp: "midnight-blue-underline", value: "Verify", type: "button", onClick: function () {
                                    resendOtp(true, keysForCustomFunction[2], keysForCustomFunction[3]);
                                } }))))))));
            },
        },
        {
            columnName: "Email",
            keysForCustomFunction: [
                "email",
                "otpOnEmail",
                "relation",
                "memberAcCode",
                "status",
            ],
            tdCustomFunction: function (keysForCustomFunction) {
                return (React.createElement(React.Fragment, null,
                    React.createElement("span", null, keysForCustomFunction[0]),
                    keysForCustomFunction[4] !== null &&
                        keysForCustomFunction[4] !== undefined &&
                        keysForCustomFunction[4] !== "" &&
                        keysForCustomFunction[4].length > 0 && (React.createElement(React.Fragment, null, keysForCustomFunction[4] === "Pending" && (React.createElement(React.Fragment, null,
                        React.createElement("div", { className: "familytagging-btn" },
                            React.createElement(EdButton, { btnTyp: "midnight-blue-underline", value: "Verify", onClick: function () {
                                    resendOtp(false, keysForCustomFunction[2], keysForCustomFunction[3]);
                                } }))))))));
            },
        },
        {
            columnName: "Status",
            key: "status",
        },
        // {
        //   columnName: "LOA",
        //   key: "loa",
        //   key2: "memberAcCode",
        //   tdCustomFunction: (key: string, key2: string) => {
        //     return (
        //       <div className="familytagging-btn">
        //         <EdButton
        //           btnTyp={"midnight-blue-underline"}
        //           value={key}
        //           onClick={() => {
        //             sendLoa(key2);
        //           }}
        //         />
        //       </div>
        //     );
        //   },
        // },
        {
            columnName: "Remove",
            keysForCustomFunction: ["remove", "memberAcCode"],
            tdCustomFunction: function (keysForCustomFunction) {
                return (React.createElement("div", { className: "familytagging-btn" },
                    React.createElement(EdButton, { btnTyp: "midnight-blue-border", value: "Delete", onClick: function () {
                            deleteFamilyMember(keysForCustomFunction[1]);
                        } })));
            },
        },
    ];
    var getFamilyDetails = function () {
        di.clients.getFamilyMemDetails({
            acCode: selectedAcount === null || selectedAcount === void 0 ? void 0 : selectedAcount.accountCode,
            page: "1",
            pageSize: "100",
        });
    };
    var getMasterRealtionShipData = function () {
        di.clients
            .getMasterRelation()
            .then(function (val) { return setMasterRelation(val); })
            .catch(function (error) { return setMasterRelation([]); });
    };
    React.useEffect(function () {
        if (selectedAcount && selectedAcount.accountCode)
            getFamilyDetails();
    }, [selectedAcount]);
    React.useEffect(function () {
        getMasterRealtionShipData();
    }, []);
    var saveFamilyTagging = function (selectedFamilyTagging) {
        return di.clients.addFamilyMemDetails(selectedFamilyTagging);
    };
    React.useEffect(function () {
        var _a;
        if (((_a = familyMemDetails.data) === null || _a === void 0 ? void 0 : _a.length) > 0) {
            var familyHeadDetails_1 = [];
            var selectedFamilyTagging_1 = {
                familyheadaccodenew: "",
                familyheadaccodeold: "",
                smsFlag: "",
                familymemberdetails: [],
            };
            familyMemDetails.data.map(function (record) { return __awaiter(void 0, void 0, void 0, function () {
                var _a, _b, familymemberdetail;
                return __generator(this, function (_c) {
                    switch (_c.label) {
                        case 0:
                            if (!(record.headAcCode !== null)) return [3 /*break*/, 2];
                            selectedFamilyTagging_1.familyheadaccodenew = record.headAcCode;
                            selectedFamilyTagging_1.familyheadaccodeold = record.headAcCode;
                            setFormData({ serachVal: record.headAcCode });
                            _a = selectedFamilyTagging_1;
                            _b = Number;
                            return [4 /*yield*/, accountDetails.getSalesuserId()];
                        case 1:
                            _a.userID = _b.apply(void 0, [_c.sent()]);
                            familyHeadDetails_1.push(record);
                            return [3 /*break*/, 3];
                        case 2:
                            familymemberdetail = {
                                relation: record.relation.toString(),
                                accode: record.memberAcCode,
                                otp: "",
                                // otponemail: record.otpOnEmail.toString(),
                                // otponsms: record.otpOnMobile.toString(),
                            };
                            selectedFamilyTagging_1.familymemberdetails.push(familymemberdetail);
                            _c.label = 3;
                        case 3: return [2 /*return*/];
                    }
                });
            }); });
            setSelectedAddFamilyMember(selectedFamilyTagging_1);
            setFamilyHeadDetails(familyHeadDetails_1);
        }
        else {
            setFormData({ serachVal: "" });
            var familyInitialObj = {
                headAcCode: undefined,
                headAcName: "",
                memberAcCode: "",
                memberName: "",
                relation: 0,
                mobileNo: "",
                otpOnMobile: 0,
                otpOnEmail: 0,
                email: "",
                btnText: "",
                status: "",
                loa: "",
                remove: "",
            };
            setFamilyHeadDetails([familyInitialObj]);
        }
        setFamilyMemberDetailsData(familyMemDetails === null || familyMemDetails === void 0 ? void 0 : familyMemDetails.data);
    }, [familyMemDetails.data]);
    var convertMasterRelation = function () {
        var masterRelations = [];
        if (MasterRelation.length > 0) {
            masterRelations = MasterRelation.map(function (record) {
                return {
                    value: record.valueid,
                    display: record.valuename,
                };
            });
        }
        return masterRelations;
    };
    var verifyOtp = function (otp, isMobile, index, callBackFunction) {
        var _a, _b, _c;
        callBackFunction(false);
        var reqobj = {
            UserId: userId,
            familyheadaccodenew: (_a = familyHeadDetails[0]) === null || _a === void 0 ? void 0 : _a.headAcCode,
            familyheadaccodeold: (_b = familyHeadDetails[0]) === null || _b === void 0 ? void 0 : _b.headAcCode,
            familymemberdetails: [],
            smsFlag: "S",
        };
        reqobj.familymemberdetails = selectedAddFamilyMember === null || selectedAddFamilyMember === void 0 ? void 0 : selectedAddFamilyMember.familymemberdetails;
        if (reqobj.familymemberdetails && ((_c = reqobj.familymemberdetails) === null || _c === void 0 ? void 0 : _c.length) > 0) {
            reqobj.familymemberdetails = reqobj.familymemberdetails.map(function (record, idx) {
                if (idx == index) {
                    if (isMobile) {
                        record.otponsms = "1";
                    }
                    else {
                        record.otponemail = "1";
                    }
                    record.otp = otp;
                }
                return record;
            });
        }
        //   setSelectedFamilyTagging(reqobj);
        saveFamilyTagging(reqobj).then(function (resp) {
            var _a, _b;
            console.log(resp);
            if (resp && resp !== null) {
                if ((resp === null || resp === void 0 ? void 0 : resp.message) != "" &&
                    ((_b = (_a = resp === null || resp === void 0 ? void 0 : resp.message) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === null || _b === void 0 ? void 0 : _b.includes("please enter correct otp for"))) {
                    callBackFunction(true);
                }
                else {
                    if (resp.status) {
                        //if(resp.data?.include(""))
                        callBackFunction(false);
                        if (isMobile) {
                            setverifyPopupMobile(false);
                        }
                        else
                            setverifyPopupEmail(false);
                        getFamilyDetails();
                    }
                }
            }
        });
    };
    return (React.createElement("div", { className: "Familytagging-pop-mainblock" },
        React.createElement("div", { className: "family-tag-head DMSanBold_18_700 d-flex justify-content-between" },
            React.createElement("div", { className: "d-flex" },
                React.createElement("div", null,
                    React.createElement("i", { className: "edel-icon-arrow-left", onClick: function () {
                            props.setFamilyTagging(false);
                        } })),
                React.createElement("div", null, "FamilyTagging")),
            React.createElement("div", { className: "mx-0 familymembtn-block" },
                React.createElement(EdButton, { btnTyp: "midnight-blue", value: "Add Family Member", disabled: familyHeadDetails &&
                        (familyHeadDetails === null || familyHeadDetails === void 0 ? void 0 : familyHeadDetails.length) > 0 &&
                        (((_a = familyHeadDetails[0]) === null || _a === void 0 ? void 0 : _a.headAcCode) === "" ||
                            ((_b = familyHeadDetails[0]) === null || _b === void 0 ? void 0 : _b.headAcCode) === null ||
                            ((_c = familyHeadDetails[0]) === null || _c === void 0 ? void 0 : _c.headAcCode) === undefined)
                        ? true
                        : false, onClick: function () {
                        // setSelectedAddFamilyMember((selectedAddFamilyMember) => {
                        //   if (
                        //     selectedAddFamilyMember.familymemberdetails === null ||
                        //     selectedAddFamilyMember.familymemberdetails === undefined ||
                        //     selectedAddFamilyMember.familymemberdetails?.length === 0
                        //   ) {
                        //     selectedAddFamilyMember.familymemberdetails = [];
                        //   }
                        //   let familyMemDetail: ICommonFamilyMemDetailsSubRequest = {
                        //     relation: "",
                        //     accode: "",
                        //     otp: "",
                        //     otponemail: "",
                        //     otponsms: "",
                        //   };
                        //   selectedAddFamilyMember.familymemberdetails.push(familyMemDetail);
                        //   return selectedAddFamilyMember;
                        // });
                        SetAddFamilyMemeber(true);
                        setResetFamilyAddForm(!resetFamilyAddForm);
                    } }))),
        React.createElement(Row, { className: "mx-0 px-0 pb-0" },
            React.createElement(GenericTable, { columns: FamilyColumn, data: familyHeadDetails, parentClassName: "salestableParentClass family-table", tableClassName: "salestableclass" })),
        React.createElement(Row, { className: "mx-0" },
            React.createElement(GenericTable, { columns: RelationColumn, data: FamilyMemberDetailsData && (FamilyMemberDetailsData === null || FamilyMemberDetailsData === void 0 ? void 0 : FamilyMemberDetailsData.length) > 0
                    ? FamilyMemberDetailsData.filter(function (val) { return val.headAcCode != (selectedAcount === null || selectedAcount === void 0 ? void 0 : selectedAcount.accountCode); })
                    : [], loader: FamilyMemDetailsCommon.loader, parentClassName: "salestableParentClass", tableClassName: "salestableclass", rowOnClick: function (clickOnElement, index) {
                    setselectedElement(clickOnElement);
                    setSelectedIndex(index);
                } })),
        React.createElement(EdModal, { show: addFamilyMemeber, setShow: function (resp) {
                if (resp == false) {
                    SetAddFamilyMemeber(false);
                    getFamilyDetails();
                    setResetFamilyAddForm(true);
                }
            }, showFooter: false, closeDropdown: function () {
                setResetFamilyAddForm(true);
            }, modalTitle: "add-contact sales-client commonmodal addfamily-popup", size: "modal-md modal-dialog-centered", children: React.createElement(React.Fragment, null,
                React.createElement(AddFamilyMember, { SetAddFamilyMemeber: SetAddFamilyMemeber, setverifyPopupEmail: setverifyPopupEmail, setSuccessfulMsg: setSuccessfulMsg, selectedAddFamilyMember: selectedAddFamilyMember, setSelectedAddFamilyMember: setSelectedAddFamilyMember, setverifyPopupMobile: setverifyPopupMobile, masterRelation: convertMasterRelation(), familyHeadDetails: !!familyHeadDetails && familyHeadDetails[0], getFamilyDetails: getFamilyDetails, setResetFamilyAddForm: setResetFamilyAddForm, resetFamilyAddForm: resetFamilyAddForm, getVerifiedFlags: getVerifiedFlags })), stopClossOnOutsideClick: true, title: "Add Family Member" }),
        verifyPopupEmail && (React.createElement(Verificationpopup, { showPopup: verifyPopupEmail, setShowPopup: setverifyPopupEmail, title: "Email Verification", isMobile: false, emailId: selectedElement.email, resendOtp: resendOtp, verifyOtp: verifyOtp, selectedIndex: selectedIndex, otpSuccessStatus: emailOtpSentSuccess, setOtpSuccessStatus: setEmailOtpSentSuccess })),
        verifyPopupMobile && (React.createElement(Verificationpopup, { showPopup: verifyPopupMobile, setShowPopup: setverifyPopupMobile, title: "Mobile Verification", isMobile: true, mobileNo: selectedElement.mobileNo, resendOtp: resendOtp, verifyOtp: verifyOtp, selectedIndex: selectedIndex, otpSuccessStatus: mobileOtpSentSuccess, setOtpSuccessStatus: setMobileOtpSentSuccess })),
        successfulMsg && (React.createElement(MessagePopup, { title: "Family member is successfully added", imgContent: resetpassword }))));
};
export default FamilyTaggingPop;
